import type { SVGProps } from 'react';

const SvgVolumeMute = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M21.707 9.207L20.293 7.793L17.5 10.586L14.707 7.793L13.293 9.207L16.086 12L13.293 14.793L14.707 16.207L17.5 13.414L20.293 16.207L21.707 14.793L18.914 12L21.707 9.207Z" />
    <path d="M10.9941 20.0352L5.80371 16.0293H2.00586V8.0293H5.79786L10.9941 3.94043L10.9941 20.0352ZM4.00586 14.0293H6.48535L8.99414 15.9648V8.05957L6.49121 10.0293H4.00586V14.0293Z" />
  </svg>
);
export default SvgVolumeMute;
